import React, { Component } from 'react'
import { StyledModal } from './styles'

class ModalPage extends Component {
  constructor(props) {
    super(props)
    this.state = {}
  }

  render() {
    const { isOpen, fnSwitch, contentChild, ignoreBackgroundClick, ignoreEscapeKeydown, ...rest } = this.props
    return (
      <StyledModal
        isOpen={isOpen}
        onBackgroundClick={ignoreBackgroundClick ? null : fnSwitch}
        onEscapeKeydown={ignoreEscapeKeydown ? null : fnSwitch}
        {...rest}
      >
        {contentChild}
      </StyledModal>
    );
  }
}

export default ModalPage;
